module.exports = __webpack_public_path__ + "static/background-e0ee6bf2135f7cd0ab8123e1e5dbf6fc.jpg";